import React, { Component } from "react";
import { object, string } from "prop-types";
import { Table, FormControl, Tooltip, OverlayTrigger } from "react-bootstrap";
import _ from 'lodash'

// utils
import { createQuery, runQuery } from "../../../utils/KeenReport";
import { formatPercentage } from "../../../utils/numeral";

// components
import Spinner from "../../Spinner";

class FunnelOnTableWithFilters extends Component {
  constructor(props) {
    super(props);

    let uniqueId;
    if (this.props.video) {
      uniqueId =
        "regularfunnelwithclicksinbars" +
        this.props.video.id +
        this.props.actor;
    } else {
      uniqueId =
        "regularfunnelwithclicksinbars" +
        this.props.campaign.id +
        this.props.actor;
    }

    this.state = {
      isLoading: true,
      hasError: false,
      uniqueId: uniqueId,
      final: [],
      filter_group_by: "parsed_user_agent.browser.family"
    };

    this.runKeen = this.runKeen.bind(this);
    this.changeState = this.changeState.bind(this);
    this.createQueries = this.createQueries.bind(this);
    this.buildQueriesForPeople = this.buildQueriesForPeople.bind(this);
    this.buildQueriesForEvents = this.buildQueriesForEvents.bind(this);
    this.calculateRatios = this.calculateRatios.bind(this);
    this.changeFilterGroupBy = this.changeFilterGroupBy.bind(this);
    this.labelName = this.labelName.bind(this);
    this.buildTooltip = this.buildTooltip.bind(this);
  }
  componentDidMount() {
    this.runKeen(this.props);
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 2000);
  }
  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.timeframe, this.props.timeframe)) {
      this.changeState("loading");
      this.runKeen(nextProps);
      this.calculateRatios(nextProps);
    }
    if (!_.isEqual(nextProps.filters, this.props.filters)) {
      this.changeState("loading");
      this.runKeen(nextProps);
      this.calculateRatios(nextProps);
    }
    if (!_.isEqual(nextProps.labelFilter, this.props.labelFilter)) {
      this.runKeen(nextProps);
      this.calculateRatios(nextProps);
    }
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 2000);
  }
  changeFilterGroupBy(filter) {
    let filter_group_by;
    if (filter === "device") {
      filter_group_by = "parsed_user_agent.device.family";
    } else if (filter === "network") {
      filter_group_by = "connection.effectiveType";
    } else {
      filter_group_by = "parsed_user_agent.browser.family";
    }
    this.setState(
      {
        filter_group_by
      },
      () => {
        this.runKeen(this.props);
      }
    );
  }
  changeState(type) {
    let isLoading, hasError;
    switch (type) {
      case "loading":
        isLoading = true;
        hasError = false;
        break;
      case "error":
        isLoading = false;
        hasError = true;
        break;
      case "done":
        isLoading = false;
        hasError = false;
        break;
      default:
        isLoading = false;
        hasError = false;
        break;
    }

    this.setState({
      isLoading,
      hasError
    });
  }
  buildQueriesForPeople(props) {
    const { campaign, timeframe, video, filters } = props;
    let queries = [];
    let { filter_group_by } = this.state;
    // Cliques
    queries.push(
      createQuery(
        "count_unique",
        "url_expanded",
        timeframe,
        null,
        video,
        "viewer_id",
        null,
        filters,
        [filter_group_by]
      )
    );
    // Visitas
    queries.push(
      createQuery(
        "count_unique",
        "video_recomended",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        filters,
        [filter_group_by]
      )
    );
    // Plays
    queries.push(
      createQuery(
        "count_unique",
        "video_unique_click",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        filters,
        [filter_group_by]
      )
    );
    // Understanding
    queries.push(
      createQuery(
        "count",
        "user_interacted",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        [
          ...filters,
          {
            operator: "eq",
            property_name: "source",
            property_value: "entendeu-diferenca"
          },
          { operator: "eq", property_name: "value", property_value: "sim" }
        ],
        [filter_group_by]
      )
    );
    // Conversoes
    queries.push(
      createQuery(
        "count",
        "ux",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        [
          ...filters,
          {
            operator: "eq",
            property_name: "source",
            property_value: "baixar-app"
          }
        ],
        [filter_group_by]
      )
    );
    return queries;
  }
  buildQueriesForEvents(props) {
    const { campaign, timeframe, video, filters } = props;
    let queries = [];
    let { filter_group_by } = this.state;
    // Cliques
    queries.push(
      createQuery(
        "count",
        "url_expanded",
        timeframe,
        null,
        video,
        null,
        null,
        filters,
        [filter_group_by]
      )
    );
    // Visitas
    queries.push(
      createQuery(
        "count",
        "video_recomended",
        timeframe,
        campaign,
        video,
        null,
        null,
        filters,
        [filter_group_by]
      )
    );
    // Plays
    queries.push(
      createQuery(
        "count",
        "video_unique_click",
        timeframe,
        campaign,
        video,
        null,
        null,
        filters,
        [filter_group_by]
      )
    );
    // Understanding
    queries.push(
      createQuery(
        "count",
        "user_interacted",
        timeframe,
        campaign,
        video,
        null,
        null,
        [
          ...filters,
          {
            operator: "eq",
            property_name: "source",
            property_value: "entendeu-diferenca"
          },
          { operator: "eq", property_name: "value", property_value: "sim" }
        ],
        [filter_group_by]
      )
    );
    // Conversoes
    queries.push(
      createQuery(
        "count",
        "ux",
        timeframe,
        campaign,
        video,
        null,
        null,
        [
          ...filters,
          {
            operator: "eq",
            property_name: "source",
            property_value: "baixar-app"
          }
        ],
        [filter_group_by]
      )
    );

    return queries;
  }
  createQueries(props) {
    const { actor } = props;
    let queries;
    if (actor === "pessoas") {
      queries = this.buildQueriesForPeople(props);
    } else {
      queries = this.buildQueriesForEvents(props);
    }
    return queries;
  }
  calculateRatios(props) {
    const { totalResults } = props;
    let newFinal = this.state.final.map(line => {
      line["clickRatio"] = line.clicks / totalResults.clicks;
      line["visitRatio"] = line.visits / totalResults.visits;
      line["playRatio"] = line.plays / totalResults.plays;
      line["understandingRatio"] =
        line.understandings / totalResults.understandings;
      line["conversionRatio"] = line.conversions / totalResults.conversions;
      if (isNaN(line["clickRatio"])) line["clickRatio"] = "-";
      if (isNaN(line["visitRatio"])) line["visitRatio"] = "-";
      if (isNaN(line["playRatio"])) line["playRatio"] = "-";
      if (isNaN(line["understandingRatio"])) line["understandingRatio"] = "-";
      if (isNaN(line["conversionRatio"])) line["conversionRatio"] = "-";
      return line;
    });

    this.setState({
      final: newFinal
    });
  }
  buildTooltip(label, text) {
    let tooltip = <Tooltip id="tooltip">{text}</Tooltip>;
    let overlay = (
      <OverlayTrigger placement="right" overlay={tooltip}>
        <p>{label}</p>
      </OverlayTrigger>
    );

    return overlay;
  }
  labelName(label) {
    switch (label) {
      case "4g":
        // return "Muito Rápida";
        return this.buildTooltip(
          "Muito rápida",
          "Rede adequada para transferência de videos em alta qualidade, video em tempo real, etc."
        );
      case "3g":
        return this.buildTooltip(
          "Rápida",
          "Rede adequada para transferência de assets grandes como imagens de alta resolução, audio e pequenos videos."
        );
      case "2g":
        return this.buildTooltip(
          "Lenta",
          "Rede adequada para transferências de pequenas imagens."
        );
      case "slow-2g":
        return this.buildTooltip(
          "Muito Lenta",
          "Rede adequada para pequenas transferências de páginas de texto."
        );
      case null:
        return "Não informado";
      default:
        return label;
    }
  }
  runKeen(props) {
    this.changeState("loading");
    let queries = this.createQueries(props);
    let { filter_group_by } = this.state;
    runQuery(queries)
      .then(res => {
        this.changeState("done");
        let final = [];

        let iterador = [
          {
            step: "clicks",
            resultsByBrowser: res[0]
          },
          {
            step: "visits",
            resultsByBrowser: res[1]
          },
          {
            step: "plays",
            resultsByBrowser: res[2]
          },
          {
            step: "understandings",
            resultsByBrowser: res[3]
          },
          {
            step: "conversions",
            resultsByBrowser: res[4]
          }
        ];

        // Visitas
        iterador.forEach(stepAndResultsByBrowser => {
          let resultsByBrowser = stepAndResultsByBrowser["resultsByBrowser"];
          let step = stepAndResultsByBrowser["step"];
          resultsByBrowser.result.forEach(countByBrowser => {
            let exists = false;
            let objeto = {
              label: countByBrowser[filter_group_by],
              clicks: 0,
              visits: 0,
              plays: 0,
              understandings: 0,
              conversions: 0
            };
            final.forEach(finalBrowser => {
              if (finalBrowser["label"] === objeto["label"]) {
                objeto = finalBrowser;
                exists = true;
              }
            });
            objeto[step] = countByBrowser["result"];
            if (!exists) {
              final.push(objeto);
            }
          });
        });

        this.setState({
          final
        });

        this.calculateRatios(this.props);
      })
      .catch(err => {
        console.log("Erro rodando a query do Keen.", err);
        this.changeState("error");
      });
  }
  render() {
    let { isLoading, hasError } = this.state;
    return (
      <div>
        <div className={isLoading ? "hidden" : ""}>
          <Table bordered striped>
            <thead>
              <tr>
                <th width="15%">Overview</th>
                <th width="15%">Cliques</th>
                <th width="15%">Visitas</th>
                <th width="15%">Plays</th>
                <th width="15%">Entendimentos</th>
                <th width="15%">Conversão</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <FormControl
                    componentClass="select"
                    defaultValue="browser"
                    onChange={e => {
                      this.changeFilterGroupBy(e.target.value);
                    }}
                  >
                    <option value="browser">Filtrar por Navegador</option>
                    <option value="device">
                      Filtrar por Dispositivo Móvel
                    </option>
                    <option value="network">Filtrar por Rede</option>
                  </FormControl>
                </td>
                <td>{this.props.totalResults.clicks}</td>
                <td>{this.props.totalResults.visits}</td>
                <td>{this.props.totalResults.plays}</td>
                <td>{this.props.totalResults.understandings}</td>
                <td>{this.props.totalResults.conversions}</td>
              </tr>
              {this.state.final.map(line => (
                <tr key={line.label}>
                  <td>
                    <a
                      className="text-link"
                      role="button"
                      onClick={() => {
                        this.props.changeFilter(
                          line.label,
                          this.state.filter_group_by
                        );
                      }}
                    >
                      {this.labelName(line.label)}
                    </a>
                  </td>
                  <td>
                    {line.clicks} ({formatPercentage(line.clickRatio, "0[.]0%")})
                  </td>
                  <td>
                    {line.visits} ({formatPercentage(line.visitRatio, "0[.]0%")})
                  </td>
                  <td>
                    {line.plays} ({formatPercentage(line.playRatio, "0[.]0%")})
                  </td>
                  <td>
                    {line.understandings} ({formatPercentage(
                      line.understandingRatio,
                      "0[.]0%"
                    )})
                  </td>
                  <td>
                    {line.conversions} ({formatPercentage(
                      line.conversionRatio,
                      "0[.]0%"
                    )})
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <Spinner
          isLoading={isLoading}
          hasError={hasError}
          runKeen={() => {
            this.runKeen(this.props);
          }}
        />
      </div>
    );
  }
}

FunnelOnTableWithFilters.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
};

export default FunnelOnTableWithFilters;



// WEBPACK FOOTER //
// ./src/components/charts/Funnels/FunnelOnTableWithFilters.js